import React from 'react'
import MySwitch from '../Interactions/MySwitch'

const InputTextWithSwitch = ({ id, text, selected, handleChange=()=>{} }) => {
  return (
    <div className='bg-pureWhite rounded-3xl py-3 px-4 w-full flex justify-between shadow-md border-[1px] border-gray-100'>
      <p className='text-base font-normal text-[#8F8F8F]'>{text}</p>
      <MySwitch value={selected} onChange={(value)=>handleChange(id, value)} />
    </div>
  )
}

export default InputTextWithSwitch
